export const BooksSettings = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.26137 8.84766H8.3402C8.3063 8.84766 8.31383 8.91638 8.42098 8.97132C8.50669 9.01527 8.51889 9.16852 8.51427 9.23965V14.0009H10.4749V9.29278C10.403 8.97461 9.83973 8.86346 9.56708 8.84766H9.26137Z"
      fill="currentColor"
    />
    <path
      d="M6.07387 7.13672H5.1527C5.1188 7.13672 5.12633 7.22823 5.23348 7.30139C5.31919 7.35992 5.33139 7.56399 5.32677 7.6587V13.999H7.28742V7.72946C7.21551 7.30578 6.65223 7.15777 6.37958 7.13672H6.07387Z"
      fill="currentColor"
    />
    <path
      d="M2.93911 5.20117H2.01794C1.98403 5.20117 1.99157 5.3182 2.09871 5.41176C2.18442 5.4866 2.19662 5.74756 2.19201 5.86868V13.9766H4.15265V5.95916C4.08074 5.41736 3.51746 5.22809 3.24481 5.20117H2.93911Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.85712 3.71078H2V2H8.85712C9.70856 2 10.9667 2.24788 12.0365 3.0166C13.1501 3.81673 14 5.14276 14 7.13233V13.9754H12.2857V7.13233C12.2857 5.70034 11.707 4.88791 11.0348 4.40495C10.319 3.89059 9.43424 3.71078 8.85712 3.71078Z"
      fill="currentColor"
    />
  </svg>
);
